import { Link } from 'react-router-dom';

const ROLES = [
  { title: '원장님', points: ['일정·출결을 한 화면에서 관리', '수납과 바우처 내역 대조', '월 결산과 회의록 정리'] },
  { title: '선생님', points: ['오늘 수업과 처리할 일 확인', '치료 과제 배정과 평가', '기록 초안으로 문서 시간 단축'] },
  { title: '보호자', points: ['아이의 오늘 과제 확인', '자녀 모드로 집에서 함께 수행', '동의 내역을 직접 관리'] },
];

const TRUST = [
  { title: '민감정보 암호화', text: '장애유형·연락처 같은 민감정보는 암호화해 보관합니다.' },
  { title: '센터별 데이터 분리', text: '다른 센터의 데이터는 볼 수 없도록 서버에서 막습니다.' },
  { title: '기록이 남는 접근', text: '중요한 동작은 감사 로그에 남아 원장님이 확인할 수 있습니다.' },
];

const STEPS = [
  { title: '센터 열기', text: '원장님이 가입하면 무료체험으로 센터가 열립니다.' },
  { title: '함께 쓰기', text: '선생님은 가입 코드로, 보호자는 연결 코드로 들어옵니다.' },
  { title: '필요한 만큼 확장', text: '센터에 맞는 요금제와 기능을 고릅니다.' },
];

/** 서비스 소개. 로그인 없이 볼 수 있다. 실제 기능만 적고, 수치나 후기는 근거가 있을 때만 넣는다. */
export function About() {
  return (
    <article className="about">
      <header className="about-hero">
        <p className="eyebrow">발달재활·심리상담센터 통합 관리</p>
        <h2>센터의 하루와 가정의 실천을 하나로</h2>
        <p className="about-lead">일정, 출결, 수납, 치료 과제, 보호자 소통을 SelfOn 하나로 이어 갑니다.</p>
        <div className="about-actions">
          <Link to="/" className="btn btn-primary">무료로 시작하기</Link>
          <Link to="/pricing" className="btn btn-outline">요금 보기</Link>
        </div>
      </header>

      <section aria-labelledby="about-roles">
        <h3 id="about-roles">역할마다 필요한 화면</h3>
        <ul className="about-grid">
          {ROLES.map((r) => (
            <li key={r.title} className="about-card">
              <h4>{r.title}</h4>
              <ul>{r.points.map((p) => <li key={p}>{p}</li>)}</ul>
            </li>
          ))}
        </ul>
      </section>

      <section aria-labelledby="about-steps">
        <h3 id="about-steps">시작하는 방법</h3>
        <ol className="about-steps">
          {STEPS.map((s) => <li key={s.title}><strong>{s.title}</strong><span>{s.text}</span></li>)}
        </ol>
      </section>

      <section aria-labelledby="about-trust">
        <h3 id="about-trust">아이의 정보를 지키는 방식</h3>
        <ul className="about-grid">
          {TRUST.map((t) => <li key={t.title} className="about-card"><h4>{t.title}</h4><p>{t.text}</p></li>)}
        </ul>
      </section>

      <section className="about-cta" aria-labelledby="about-cta">
        <h3 id="about-cta">궁금한 점이 있으신가요?</h3>
        <p>자주 묻는 질문을 보거나 고객센터로 문의해 주세요.</p>
        <Link to="/support" className="btn btn-outline">고객센터</Link>
      </section>
    </article>
  );
}
